import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Form, Input, Select, Image } from "antd";
import HeadingBack from "../components/common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { render } from "@testing-library/react";

function Slider() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);

  const [sliderDetails, setSliderDetails] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const { slider_list } = useSelector((state) => ({
    slider_list: state?.allApi?.slider_list || {},
  }));

  const listData = slider_list?.data ? slider_list?.data : [];

  useEffect(() => {
    dispatch(allApiAction.getSliders(page));

    return () => { };
  }, []);


  const handleDelete = async (e) => {
    setShowDelete(false);
    await dispatch(allApiAction.deleteSlider({ id: e, page: page }));
    dispatch(allApiAction.getSliders(page));
  };

  const showModal = (e) => {
    setSliderDetails(e);
    setIsModalOpen(true);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const files = event.target.files;
      setSelectedFile(files);
    }
  };

  const handleAddTextChange = (event) => {
    const { name, value } = event.target;
    setSliderDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const showModalAdd = (e) => {
    setSliderDetails(e);
    setIsModalOpen(true);
  };

  const handleCancelAdd = () => {
    setIsModalOpen(false);
  };
  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Slider",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(e);
      },
      onCancel() {
      },
    });
  };

  const columns = [
    {
      width: "10%",
      key: "image",
      title: "Image",
      dataIndex: "image",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "50px" }}>
              <Image src={URL?.API_BASE_URL + item?.image}
                alt="N/A" />
            </div>
          </>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?.id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleOk = async () => {

    if (!sliderDetails?.title) {
      toast.error("Please enter a title");
      return;
    };
    if (!selectedFile && !sliderDetails?.id) {
      toast.error("Please select image");
      return;
    };

    const data = new FormData();
    data.append("title", sliderDetails?.title);
    if (selectedFile) {
      for (let i = 0; i < selectedFile?.length; i++) {
        data.append("image", selectedFile[i]);
      }
    };
    try {
      if (sliderDetails?.id) {
        data.append("id", sliderDetails?.id);
        await dispatch(allApiAction.updateSlider(data));
      } else {
        await dispatch(allApiAction.createSlider(data));
      }
      dispatch(allApiAction.getSliders(page));

      // Reset form state
      setIsModalOpen(false);
      setSliderDetails({});
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error creating category");
    };
  };

  return (
    <div>

      {/* Header Bar  */}
      <div className="flex">
        <div>
          <HeadingBack
            title={"Slider"}
            subHeading={`Total ${slider_list?.total || 0} Slider`}
          />
        </div>

        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => showModalAdd()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Pagination table  */}
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              // handlePahegi(current);
            },
            hideOnSinglePage: true,
            total: slider_list?.total ? slider_list?.total : 0,
          }}
        />
      </div>

      {/* Add Edit Modal */}
      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title="Create Slider"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancelAdd}
      >
        {/* Name Input */}
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="off"
            className="form-control"
            placeholder="Title"
            name="title"
            value={sliderDetails?.title}
            onChange={handleAddTextChange}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <input
            type="file"
            // multiple
            accept="image/*"
            onChange={handleFileChange}
          />
        </Col>
      </Modal>
    </div>
  );
}

export default Slider;
